export default "__VITE_ASSET__10fc5674__"